import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { AdminReportFilters, UIState } from "../types/ui-types";
import { useQuery } from "@tanstack/react-query";
import { adminFetchReports } from "../api/report.api";

interface UseReportsProps {
  filters: AdminReportFilters;
  enabled: boolean;
}

const useAdminAllReports = ({ filters, enabled }: UseReportsProps) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken]),
  );

  const { data: reportsData, isLoading: isLoadingReports } = useQuery({
    queryKey: ["adminAllReports", filters],
    queryFn: () => adminFetchReports(filters, bearerToken),
    enabled: !!bearerToken && enabled,
  });

  return {
    reportsData,
    isLoadingReports,
  };
};

export default useAdminAllReports;
